// 乘车码调用——微信，主流程
const wxMainRoutes = Array.from({ length: 13 }, (_, i) => ({
  path: `code/wx/index${i + 1}`,
  name: `codeWxIndex${i + 1}`,
  component: () => import(`@/views/traffic/code/wx/index${i + 1}.vue`)
}))

// 乘车码调用——支付宝，主流程
const zfbMainRoutes = Array.from({ length: 7 }, (_, i) => ({
  path: `code/zfb/index${i + 1}`,
  name: `codeZfbIndex${i + 1}`,
  component: () => import(`@/views/traffic/code/zfb/index${i + 1}.vue`)
}))

export default {
  path: '/traffic',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 乘车码调用——微信，开始
    ...wxMainRoutes,

    // 乘车码调用——支付宝，主流程
    ...zfbMainRoutes
  ]
}
